module.exports = __webpack_public_path__ + "static/media/lunchType-salad.187ee60d.jpg";